import React from 'react';
import {Table} from '@/web-components';
import {getColumns} from './TaskReportUtil';
import {NullTooltip} from '../../../shared/components/tooltips/FinancialCategoryTooltip';

export const getBaseLevelTableHeader = (columns, customFieldDefinitions) => {
	const headerList = getColumns(customFieldDefinitions);

	return (
		<Table.Header>
			{headerList.map(item => {
				const Tooltip = item.Tooltip ?? NullTooltip;

				return (
					<Table.HeaderColumn
						key={item.id}
						usePadding
						align={'left'}
						visible={columns[item.eyeOptionId] ?? true}
						width="MEDIUM"
						{...item.extraProps}
					>
						<Tooltip>
							<Table.HeaderColumn.Title>{item.title}</Table.HeaderColumn.Title>
						</Tooltip>
					</Table.HeaderColumn>
				);
			})}
		</Table.Header>
	);
};
